module.exports = __webpack_public_path__ + "static/media/EmptyState.539f1acb.png";